<template>
  <section class="why full-page-section">
    <div class="content">
      <h3 v-html="strings.h2"></h3>
    </div>
  </section>
</template>

<script>
import data from '@/data/strings.json'
export default {
  name: 'Why',
  data () {
    return {
      page: {},
      strings: data.why
    }
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .play {
  }
</style>
